var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWatchersCoven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1490 236",
    style: {
      enableBackground: "new 0 0 1490 236"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.5,213.9L247.2,92l-1.4-4.1h10.7l40,126h-10.6L271.2,168h-44.1l-14.6,45.9H208.5z M249.3,98.4 l-20.9,65.6H270L249.3,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333.5,92h-46.9v-4.1h104.5V92h-46.9v121.9h-10.6L333.5,92L333.5,92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M385.1,150.8c0-36.3,27.7-65.8,61.7-65.8c25.8,0,47.9,17,57,41h-11.3c-7.8-21.7-25.2-36.9-45.7-36.9 c-27.7,0-50,27.7-50,61.7s22.3,61.7,50,61.7c20.5,0,37.9-15.2,45.7-36.9h11.3c-9,24.2-31.1,41-57,41 C412.8,216.6,385.1,187.1,385.1,150.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M525.7,213.9H515v-126h10.7v60.9H590V87.9h10.5v126H590v-61.1h-64.3L525.7,213.9L525.7,213.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M611.5,213.9v-126h57.6V92h-46.9v46.3h34v4.1h-34v67.4h46.9v4.1L611.5,213.9L611.5,213.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M690,213.9h-10.7v-126h42c19.3,0.2,35,15.2,35,34.6s-15.6,35.2-35,35.4h-1.2l39.1,55.9h-13.5L706.5,158H690 L690,213.9L690,213.9z M690,153.9h31.3c12.9-0.4,23.4-14.1,23.4-31.3c0-17.2-10.5-30.1-23.4-30.5H690V153.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M837.2,182.2c0-13.3-15.8-22.1-33.6-31.6c-13.9-7.4-35.2-14.1-35.2-35.2c-0.2-20.7,16.2-30.1,37.1-30.1 c20.1,0,37.3,13.9,37.3,29.7H835c0-11.3-11.9-26.8-29.5-26.8c-13.3,0-25.4,9.2-25.4,21.5c0,15.4,15,23.2,32.4,31.3 c16.4,8,36.7,20.5,36.7,37.9c0,15.6-10.7,38.1-43.6,38.1c-23.4,0-39.7-16.8-39.7-40.4h7.6c1.2,22.5,11.7,37.5,30.9,37.5 C819.8,214.1,837.2,204.3,837.2,182.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M915.9,124.6c0-50.7,38.6-91.9,86.2-91.9c36.1,0,67,23.8,79.6,57.2h-15.7c-10.9-30.3-35.2-51.5-63.8-51.5 c-38.6,0-69.8,38.6-69.8,86.2s31.2,86.1,69.8,86.1c28.6,0,53-21.2,63.8-51.5h15.7c-12.6,33.8-43.5,57.2-79.6,57.2 C954.5,216.4,915.9,175.2,915.9,124.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1093.6,151c0-36.1,29.3-65.4,65.4-65.4c36.3,0,65.4,29.3,65.4,65.4c0,36.3-29.1,65.4-65.4,65.4 C1123,216.4,1093.6,187.3,1093.6,151z M1105.4,151c1.8,34.6,27.1,62.8,56.8,62.8c29.5,0,52.2-28.1,50.3-62.8 c-1.6-34.6-27.1-62.5-56.8-62.5C1126.2,88.5,1103.6,116.4,1105.4,151z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1271.5,213.8l-4.3-0.2h-4.3l-39.7-125.1h11l36.3,114.7l36.5-114.7h4.3L1271.5,213.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1320.4,213.8V88.5h57.2v4.1H1331v46h33.8v4.1H1331v67h46.7v4.1L1320.4,213.8L1320.4,213.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1390.2,213.8h-4.1V88.5h8.2l66,105.5V88.5h4.1v125.3h-4.1l-70.1-114.7L1390.2,213.8L1390.2,213.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.9,212.1H83.6l-40.4-176h15.2L99.9,212.1z M164.6,160.4l3.4-10.9l38.1-113.4h15.2l-40.4,124.3 L164.6,160.4 M142.9,67l-3.5-17.1l-2.4,12.9l-29.5,122.7l-2.6-8.2L139.5,27h4.3 M136.9,38.1l4.3-6.7l17.8,87.6l-2.6,8.1 l-13.5-60.1"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "140.3,49.9 132.9,20.2 136.6,18.8 143.8,44.5  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 139.9,
    cy: 42,
    r: 7.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWatchersCoven);
export default __webpack_public_path__ + "static/media/logo-watchers-coven.5f9701406e527851c8a0f2bfbd41fcec.svg";
export { ForwardRef as ReactComponent };